const DEFAULT_PROFILE = {
    positiveTokens: [
        'aria',
        'jenny',
        'zira',
        'samantha',
        'ava',
        'michelle',
        'emma',
        'libby',
        'sonia',
        'natasha',
        'sara',
        'susan',
        'female',
        'woman',
        'girl',
        'google us english',
        'google uk english female'
    ],
    negativeTokens: [
        'david',
        'guy',
        'mark',
        'matthew',
        'male',
        'man',
        'boy',
        'ryan'
    ]
};

const BUG_BAND_PROFILE = {
    positiveTokens: [
        'aria',
        'jenny',
        'zira',
        'samantha',
        'ava',
        'michelle',
        'emma',
        'libby',
        'google uk english female',
        'female',
        'woman'
    ],
    negativeTokens: [
        'david',
        'male',
        'man',
        'guy',
        'ryan',
        'matthew'
    ]
};

const VOICE_PROFILES = {
    default: DEFAULT_PROFILE,
    bugBand: BUG_BAND_PROFILE
};

function resolveRuntime(runtime) {
    return runtime || (typeof window !== 'undefined' ? window : {});
}

function hasOwnProperty(target, key) {
    return Object.prototype.hasOwnProperty.call(target, key);
}

function containsVoiceToken(haystack, token) {
    if (token === 'ava') {
        return /(^|[\s-])ava([\s-]|$)/.test(haystack);
    }

    return haystack.includes(token);
}

function resolveProfile(options) {
    if (options && options.profile && VOICE_PROFILES[options.profile]) {
        return VOICE_PROFILES[options.profile];
    }

    return DEFAULT_PROFILE;
}

export function isAppleSafariSpeechContext(runtime) {
    const root = resolveRuntime(runtime);
    const navigatorObject = root && root.navigator ? root.navigator : {};
    const userAgent = String(navigatorObject.userAgent || '').toLowerCase();
    const vendor = String(navigatorObject.vendor || '').toLowerCase();
    const platform = String(navigatorObject.platform || '').toLowerCase();

    const isAppleVendor = vendor.includes('apple');
    const isSafari =
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('chromium') &&
        !userAgent.includes('crios') &&
        !userAgent.includes('fxios') &&
        !userAgent.includes('edg') &&
        !userAgent.includes('opr');
    const isiOSLike =
        userAgent.includes('iphone') ||
        userAgent.includes('ipad') ||
        userAgent.includes('ipod') ||
        userAgent.includes('mobile/');
    const isMac = platform.includes('mac') || userAgent.includes('macintosh');

    return isAppleVendor && isSafari && isMac && !isiOSLike;
}

export function isSafariNarrationVoiceBoostEnabled(runtime) {
    const root = resolveRuntime(runtime);

    if (root && root.controlTower && typeof root.controlTower.getFlag === 'function') {
        return root.controlTower.getFlag('safariNarrationVoiceBoost', false) === true;
    }

    if (root && root.__FF && hasOwnProperty(root.__FF, 'safariNarrationVoiceBoost')) {
        return root.__FF.safariNarrationVoiceBoost === true;
    }

    if (root && root.ScratchJrFlags && hasOwnProperty(root.ScratchJrFlags, 'safariNarrationVoiceBoost')) {
        return root.ScratchJrFlags.safariNarrationVoiceBoost === true;
    }

    return false;
}

export function scorePreferredNarrationVoice(voice, runtime, options) {
    const profile = resolveProfile(options);
    const name = String(voice && voice.name || '').toLowerCase();
    const lang = String(voice && voice.lang || '').toLowerCase();
    const uri = String(voice && voice.voiceURI || '').toLowerCase();
    const haystack = `${name} ${lang} ${uri}`;

    let score = 0;

    if (lang.startsWith('en-us')) {
        score += 60;
    } else if (lang.startsWith('en')) {
        score += 45;
    }

    if (voice && voice.default) {
        score += 10;
    }

    profile.positiveTokens.forEach((token) => {
        if (containsVoiceToken(haystack, token)) {
            score += 40;
        }
    });

    ['natural', 'neural', 'online'].forEach((token) => {
        if (haystack.includes(token)) {
            score += 18;
        }
    });

    profile.negativeTokens.forEach((token) => {
        if (haystack.includes(token)) {
            score -= 30;
        }
    });

    if (isSafariNarrationVoiceBoostEnabled(runtime) && isAppleSafariSpeechContext(runtime)) {
        if (containsVoiceToken(haystack, 'samantha')) {
            score += 140;
        }

        if (containsVoiceToken(haystack, 'ava')) {
            score += 135;
        }

        if (haystack.includes('premium') || haystack.includes('enhanced')) {
            score += 35;
        }

        if (uri.includes('com.apple.speech.synthesis.voice') || uri.includes('com.apple.voice')) {
            score += 12;
        }
    }

    return score;
}
